import { render, staticRenderFns } from "./home.vue?vue&type=template&id=65ad7670&scoped=true&"
import script from "./home.vue?vue&type=script&lang=js&"
export * from "./home.vue?vue&type=script&lang=js&"
import style0 from "./home.vue?vue&type=style&index=0&id=65ad7670&prod&lang=less&scoped=true&"
import style1 from "./home.vue?vue&type=style&index=1&id=65ad7670&prod&lang=less&scoped=true&"
import style2 from "./home.vue?vue&type=style&index=2&id=65ad7670&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ad7670",
  null
  
)

export default component.exports